import React from "react";
import { Grid, TextField, Button, MenuItem } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setFormValues } from "../../../app/slices/applicationsSlice";
import MultipleSelect from "../../../components/MultipleSelect/MultipleSelect";
import natureOfOperation from "../../../assets/static/natureOfOperations.json";
import scaleOfOperation from "../../../assets/static/scaleOfOperations.json";
import solutionAttributes from "../../../assets/static/solutionAttributes.json";
import solutionObjectives from "../../../assets/static/solutionObjectives.json";
import marketOfOperation from "../../../assets/static/marketOfOperations.json";
import sourcesOfFunds from "../../../assets/static/sourcesOfFunds.json";
import deploymentDurations from "../../../assets/static/deploymentDurations.json";
import technologies from "../../../assets/static/technologies.json";

const SolutionSummaryFragment = ({ errors }) => {
  const { formValues } = useSelector(({ applications }) => applications);

  const dispatch = useDispatch();

  //use effects

  //methods
  const handleChange = (e) => {
    let inputName = e?.target?.name;
    let inputValue = e?.target?.value;

    if (inputName === "testingPeriod") {
      const re = /^[0-9]*$/;
      if (inputValue === "" || re.test(inputValue)) {
        dispatch(
          setFormValues({
            ...formValues,
            [inputName]: inputValue,
          })
        );
      }
    } else {
      dispatch(
        setFormValues({
          ...formValues,
          [inputName]: inputValue,
        })
      );
    }
  };

  //builders
  const BuildForm = () => {
    return (
      <Grid container>
        <Grid item xs={12} sm={6} md={6} className="padded-grid-item">
          <TextField
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors[`solutionName`] ? true : false}
            helperText={
              errors[`solutionName`] ? errors?.[`solutionName`]?.[0] : null
            }
            name={"solutionName"}
            id={"solution-name"}
            label={"Solution Name"}
            placeholder="A unique name or title for your solution"
            onChange={handleChange}
            value={formValues?.solutionName}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} className="padded-grid-item">
          <TextField
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors[`natureOfOperation`] ? true : false}
            helperText={
              errors[`natureOfOperation`]
                ? errors?.[`natureOfOperation`]?.[0]
                : null
            }
            name={"natureOfOperation"}
            select
            id={"nature-of-operation"}
            label={"Nature of Operation"}
            onChange={handleChange}
            value={formValues?.natureOfOperation}
          >
            {natureOfOperation.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={6} className="padded-grid-item">
          <TextField
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors[`scaleOfOperation`] ? true : false}
            helperText={
              errors[`scaleOfOperation`]
                ? errors?.[`scaleOfOperation`]?.[0]
                : null
            }
            name={"scaleOfOperation"}
            select
            id={"scale-of-operation"}
            label={"Scale of Operation"}
            onChange={handleChange}
            value={formValues?.scaleOfOperation}
          >
            {scaleOfOperation.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={6} className="padded-grid-item">
          <TextField
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors[`solutionAttribute`] ? true : false}
            helperText={
              errors[`solutionAttribute`]
                ? errors?.[`solutionAttribute`]?.[0]
                : null
            }
            name={"solutionAttribute"}
            select
            id={"solution-attribute"}
            label={"Solution Attribute"}
            onChange={handleChange}
            value={formValues?.solutionAttribute}
          >
            {solutionAttributes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.title}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="padded-grid-item">
          <MultipleSelect
            required={true}
            options={solutionObjectives}
            formValues={formValues}
            onChange={handleChange}
            errors={errors}
            label="Solution Objectives"
            name="solutionObjectives"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="padded-grid-item">
          <MultipleSelect
            required={true}
            options={marketOfOperation}
            formValues={formValues}
            onChange={handleChange}
            errors={errors}
            label="Market of Operation"
            name="marketOfOperation"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="padded-grid-item">
          <MultipleSelect
            required={true}
            options={sourcesOfFunds}
            formValues={formValues}
            onChange={handleChange}
            errors={errors}
            label="Source of Funds"
            name="sourceOfFunds"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="padded-grid-item">
          <MultipleSelect
            required={true}
            options={technologies}
            formValues={formValues}
            onChange={handleChange}
            errors={errors}
            label="Technologies Used"
            name="technologiesUsed"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="padded-grid-item">
          <Grid container>
            <Grid item xs={12} md={8} className="padded-grid-item">
              <div>
                How long will it take to test your solution (in months)?
              </div>
            </Grid>
            <Grid item xs={12} md={4} className="padded-grid-item">
              <TextField
                key={"input-testing-period"}
                required
                fullWidth
                margin="dense"
                autoComplete="new-password"
                variant="outlined"
                error={errors["testingPeriod"] ? true : false}
                helperText={
                  errors["testingPeriod"] ? errors.testingPeriod[0] : null
                }
                name="testingPeriod"
                id="testingPeriod"
                label="Testing Period (months)"
                onChange={handleChange}
                value={formValues?.testingPeriod}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="padded-grid-item">
          <Grid container>
            <Grid item xs={12} md={8} className="padded-grid-item">
              <div>
                After testing, how long will it take to deploy solution?
              </div>
            </Grid>
            <Grid item xs={12} md={4} className="padded-grid-item">
              <TextField
                key={"input-duration-to-deploy"}
                required
                fullWidth
                margin="dense"
                select
                autoComplete="new-password"
                variant="outlined"
                error={errors["deploymentDuration"] ? true : false}
                helperText={
                  errors["deploymentDuration"]
                    ? errors.deploymentDuration[0]
                    : null
                }
                name="deploymentDuration"
                id="deploymentDuration"
                label="Deployment Duration"
                onChange={handleChange}
                value={formValues?.deploymentDuration}
              >
                {deploymentDurations.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  return (
    <div className="app-padding">
      <h2 className="mb-10">Solution Summary</h2>
      {BuildForm()}
    </div>
  );
};

export default SolutionSummaryFragment;
